import { Link } from 'react-router-dom';
import { clinic } from '@/mocks/site';

export default function FinalCTA() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden" style={{ background: '#F2D16B' }}>
      <span className="deco-float-lg-alt absolute pointer-events-none hidden md:block" style={{ width: 620, height: 620, top: -240, left: -180, background: '#F8E4A8', borderRadius: '58% 42% 63% 37% / 47% 55% 45% 53%' }} aria-hidden />
      <span className="deco-float-sm absolute pointer-events-none hidden md:block" style={{ width: 480, height: 480, bottom: -200, right: -140, background: '#EFC148', borderRadius: '52% 48% 39% 61% / 58% 44% 56% 42%', opacity: 0.55 }} aria-hidden />

      <div className="relative max-w-container mx-auto px-5 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6">
            <div className="relative w-full aspect-[4/3] overflow-hidden shape-3 bg-white/40">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20editorial%20photograph%20of%20a%20calm%20young%20man%20gently%20holding%20his%20cat%20close%20while%20smiling%20softly%20at%20the%20cat%2C%20inside%20a%20bright%20modern%20warm%20veterinary%20waiting%20area%20with%20abundant%20natural%20daylight%20streaming%20through%20windows%2C%20warm%20ivory%20background%2C%20real%20human%20animal%20bond%2C%20natural%20bright%20skin%20tones%2C%20quiet%20intimate%20moment&width=840&height=630&seq=final-cta-yellow-3&orientation=landscape&nocache=true"
                alt="Owner and cat"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="lg:col-span-6">
            <h2 className="font-display font-bold text-[44px] md:text-[62px] leading-[0.98] text-cocoa">
              Ready for a better vet visit?
            </h2>
            <p className="mt-5 text-[17px] md:text-[18px] text-ink/80 leading-relaxed">We're welcoming new patients this month.</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Link to="/book" className="btn-motion inline-flex items-center justify-center gap-2 h-[54px] px-8 rounded-full bg-cocoa hover:bg-careDark text-white text-[15px] font-semibold cursor-pointer whitespace-nowrap">
                Book an Appointment
                <i className="ri-arrow-right-line text-[16px]"></i>
              </Link>
              <a href={`tel:${clinic.phone.replace(/[^0-9+]/g, '')}`} className="btn-motion inline-flex items-center justify-center gap-2 h-[54px] px-8 rounded-full border border-cocoa/40 bg-white/60 backdrop-blur text-cocoa text-[15px] font-semibold cursor-pointer whitespace-nowrap hover:bg-white">
                <i className="ri-phone-line text-[16px]"></i>
                Call the Clinic
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}